import { forwardRef, type HTMLAttributes, type ForwardedRef } from 'react';
import { cn } from '../lib/cn';

export const Card = forwardRef(function Card(
  { className, ...props }: HTMLAttributes<HTMLDivElement>,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <div
      ref={ref}
      className={cn('rounded-lg border border-border bg-card text-card-foreground', className)}
      {...props}
    />
  );
});

export const CardHeader = forwardRef(function CardHeader(
  { className, ...props }: HTMLAttributes<HTMLDivElement>,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return <div ref={ref} className={cn('flex flex-col gap-1.5 p-4', className)} {...props} />;
});

export const CardTitle = forwardRef(function CardTitle(
  { className, ...props }: HTMLAttributes<HTMLHeadingElement>,
  ref: ForwardedRef<HTMLHeadingElement>,
) {
  return (
    <h3 ref={ref} className={cn('text-sm font-semibold text-foreground', className)} {...props} />
  );
});

export const CardDescription = forwardRef(function CardDescription(
  { className, ...props }: HTMLAttributes<HTMLParagraphElement>,
  ref: ForwardedRef<HTMLParagraphElement>,
) {
  return <p ref={ref} className={cn('text-sm text-muted-foreground', className)} {...props} />;
});

export const CardContent = forwardRef(function CardContent(
  { className, ...props }: HTMLAttributes<HTMLDivElement>,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return <div ref={ref} className={cn('p-4 pt-0', className)} {...props} />;
});

export const CardFooter = forwardRef(function CardFooter(
  { className, ...props }: HTMLAttributes<HTMLDivElement>,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return <div ref={ref} className={cn('flex items-center p-4 pt-0', className)} {...props} />;
});
